import ProductCard from './ProductCard';
import './styles.scss';

const ProductCards = ({ data }) => (
    <section className="container">
        <div className="inner-container type-2">
            <div className="product-card-container">
                {data.map((item, index) => (
                    <ProductCard
                        key={item.title}
                        index={index}
                        title={item.title}
                        text={item.text}
                        img={item.img}
                        logo={item.logo}
                    />
                ))}
            </div>
        </div>
    </section>
);

export default ProductCards;
